/** The shell's line icons, from the Mist static pages. 18px, stroke 1.25. */

const S = { stroke: "currentColor", strokeWidth: 1.25, fill: "none" } as const;

export function IconHome() {
  return <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M3 8.2 9 3.2l6 5V15H3V8.2z" {...S} strokeLinejoin="round" /></svg>;
}
export function IconJobs() {
  return <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M4 5h10M4 9h10M4 13h6" {...S} strokeLinecap="round" /></svg>;
}
export function IconCompanies() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path d="M3.4 15V6.2L9 3.4l5.6 2.8V15" {...S} strokeLinejoin="round" />
      <path d="M7.2 15V9.6h3.6V15M6.2 8h1.2M10.6 8h1.2M6.2 11h1.2" {...S} strokeLinecap="round" />
    </svg>
  );
}
export function IconInterviews() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <rect x="3.2" y="4.2" width="11.6" height="10.6" rx="1.2" {...S} />
      <path d="M3.2 7.4h11.6M6 3.2v2.2M12 3.2v2.2" {...S} strokeLinecap="round" />
    </svg>
  );
}
export function IconMe() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <circle cx="9" cy="6.4" r="2.3" {...S} />
      <path d="M4.2 14.2c.7-2.4 2.4-3.6 4.8-3.6s4.1 1.2 4.8 3.6" {...S} strokeLinecap="round" />
    </svg>
  );
}
export function IconAgent() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path d="M3.5 4.4h11A1.3 1.3 0 0 1 15.8 5.7v6.1a1.3 1.3 0 0 1-1.3 1.3H8L5.2 15V13.1H4.5A1.3 1.3 0 0 1 3.2 11.8V5.7A1.3 1.3 0 0 1 4.5 4.4z" {...S} strokeLinejoin="round" />
    </svg>
  );
}
export function IconFold() {
  return <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M10.5 5 6.5 9l4 4" {...S} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export function IconSun() {
  return (
    <svg className="icon-sun" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <circle cx="9" cy="9" r="3.1" {...S} />
      <path d="M9 2.4v1.6M9 14v1.6M2.4 9h1.6M14 9h1.6M4.1 4.1l1.1 1.1M12.8 12.8l1.1 1.1M4.1 13.9l1.1-1.1M12.8 5.2l1.1-1.1" {...S} strokeLinecap="round" />
    </svg>
  );
}
export function IconMoon() {
  return (
    <svg className="icon-moon" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path d="M11.6 3.4A6.1 6.1 0 1 0 14.6 12 5.1 5.1 0 0 1 11.6 3.4z" {...S} strokeLinejoin="round" />
    </svg>
  );
}
/** The way out: a door with an arrow leaving it. Drawn rather than borrowed
 *  so it sits on the same 18px grid and the same stroke as its two
 *  neighbours in the top bar. */
export function IconOut() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path d="M7.2 3.2H4.4a1.2 1.2 0 0 0-1.2 1.2v9.2a1.2 1.2 0 0 0 1.2 1.2h2.8" {...S} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 5.8 14.2 9l-3.2 3.2M14.2 9H7.4" {...S} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
/** Help: a question mark in a ring, on the same grid as its neighbours. */
export function IconHelp() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <circle cx="9" cy="9" r="6.2" {...S} />
      <path d="M7.1 7.2a1.95 1.95 0 0 1 3.8.5c0 1.3-1.9 1.7-1.9 2.9" {...S} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="9" cy="12.6" r=".55" fill="currentColor" />
    </svg>
  );
}
export function IconGlobe() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <circle cx="9" cy="9" r="6.2" {...S} />
      <path d="M3.2 9h11.6M9 2.8c-1.8 1.8-2.7 3.9-2.7 6.2s.9 4.4 2.7 6.2M9 2.8c1.8 1.8 2.7 3.9 2.7 6.2s-.9 4.4-2.7 6.2" {...S} />
    </svg>
  );
}
export function IconDock() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <rect x="1.75" y="2.75" width="12.5" height="10.5" rx="1.6" stroke="currentColor" strokeWidth="1.4" fill="none" />
      <rect x="9.25" y="4.1" width="3.7" height="7.8" rx="0.6" fill="currentColor" />
    </svg>
  );
}

/** The wordmark's mark: an open arc and a dot. */
export function Cmark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <path d="M66.6 25.5 A32 32 0 1 0 66.6 74.5" stroke="var(--brand-arc)" strokeWidth="14" strokeLinecap="round" fill="none" />
      <circle cx="79" cy="50" r="9.5" fill="var(--brand-dot)" />
    </svg>
  );
}

/** The same mark on a dark disc: the agent's face on the button and the panel. */
export function AgentMark() {
  return (
    <svg viewBox="0 0 100 100" aria-hidden="true">
      <circle cx="50" cy="50" r="50" fill="var(--brand-ground)" />
      <g transform="translate(8 8) scale(0.84)">
        <path d="M66.6 25.5 A32 32 0 1 0 66.6 74.5" stroke="var(--brand-arc)" strokeWidth="14" strokeLinecap="round" fill="none" />
        <circle cx="79" cy="50" r="9.5" fill="var(--brand-dot)" />
        <circle cx="82" cy="50" r="3.2" fill="var(--brand-ground)" />
      </g>
    </svg>
  );
}
